import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicenseAvatarModule } from '@portal-core/licenses/components/license-avatar/license-avatar.module';
import { CentralAvatarModule } from '@portal-core/users/components/central-avatar/central-avatar.module';
import { AuthCardHeaderComponent } from './auth-card-header.component';

@NgModule({
  declarations: [
    AuthCardHeaderComponent
  ],
  imports: [
    CentralAvatarModule,
    CommonModule,
    LicenseAvatarModule
  ],
  exports: [
    AuthCardHeaderComponent
  ]
})
export class AuthCardHeaderModule { }
